import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    doHandleDeleteItemCart,
    doHandleUpdateItemCart,
} from "../../../redux/onlineSales/onlineSales.actions";
import { doGetOnlineSalesPartyAvailability } from "../../../redux/onlineSalesProcess/onlineSalesProcess.actions";

export default function useCartDatas() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const cart = useSelector((state) => state?.onlineSales?.cart) || [];
    const waiver = useSelector((state) => state?.waiver?.waiver) || {};

    const handleDeleteItemCart = (payload) => {
        dispatch(doHandleDeleteItemCart(payload));
    };
    const handleUpdateItemCart = (payload) => {
        dispatch(doHandleUpdateItemCart(payload));
    };

    const getPriceMenu = (item = {}) => {
        return (
            parseFloat(item["qty"] || "0") * parseFloat(item["price"] || "0")
        );
    };

    const getPriceTax = (item = {}) => {
        return parseFloat(item["taxValue"] || "0");
    };

    const getSubtotal = () => {
        if (cart.length > 0) {
            const prices = cart?.map((item) => getPriceMenu(item));

            return prices?.reduce(
                (a, b) => parseFloat(a.toString()) + parseFloat(b.toString()),
                0,
            );
        }

        return 0;
    };

    const getTax = () => {
        if (cart.length > 0) {
            const taxes = cart?.map((item) => getPriceTax(item));

            return taxes?.reduce(
                (a, b) => parseFloat(a.toString()) + parseFloat(b.toString()),
                0,
            );
        }

        return 0;
    };

    const getGrandtotal = () => {
        if (cart.length > 0) {
            return getSubtotal() + getTax();
        }

        return 0;
    };

    const handleShowCapacity = (payload) => {
        dispatch(doGetOnlineSalesPartyAvailability(payload));
    };

    return {
        dispatch,
        navigate,
        cart,
        getPriceMenu,
        getPriceTax,
        getSubtotal,
        getTax,
        getGrandtotal,
        handleDeleteItemCart,
        handleUpdateItemCart,
        waiver,
        handleShowCapacity
    };
}
